import {createListenerMiddleware} from '@reduxjs/toolkit';
import {setRumLabels} from '@/config/rum';
import {
    setUUID,
    setCandidateID,
    setSourceID,
    setExid,
    setDetails,
} from '@/store/slices/chatbotDetails';

const rumLabelsListener = createListenerMiddleware();

const syncLabels = (state) => {
    const {UUID, candidateID, sourceID, exid, company} = state.chatbotDetails;
    const labels = {
        assistant_id: UUID,
        candidate_id: candidateID,
        source_id: sourceID,
        exid,
        company_id: company?.id,
        company_evo_id: company?.evo_id,
        company_name: company?.name,
    };
    const filtered = Object.fromEntries(
        Object.entries(labels).filter(([, v]) => v != null && v !== ''),
    );
    if (Object.keys(filtered).length > 0) {
        setRumLabels(filtered);
    }
};

for (const action of [setUUID, setCandidateID, setSourceID, setExid, setDetails]) {
    rumLabelsListener.startListening({
        actionCreator: action,
        effect: (_, listenerApi) => {
            syncLabels(listenerApi.getState());
        },
    });
}

export default rumLabelsListener;
